import axios from 'axios';
import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import TestApiClient from '../../LoginData/TestApiClient';


function Dkr_Table({ distCode, month, year }) {
  const [data, setData] = useState([]);
  const [heading, setHeading] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [enableLoading, setEnableLoading] = useState(null);
  const { postData } = TestApiClient();


  // ---------- Fetch Data ----------
  useEffect(() => {
    setLoading(true);

    postData(`${process.env.REACT_APP_URL}/api/dkr/search`, {
      month,
      year,
      distCode
    })
      .then(data => {
        setData(data.data || []);
        setHeading(data.heading || '');
        setMessage(data.message || '');
      })
      .catch(() => {
        setMessage("Error fetching data.");
      })
      .finally(() =>
        setTimeout(() => setLoading(false), 10)
      );
  }, [distCode, month, year]);


  // ---------- Enable Handler ----------
const handleEnable = async (fpsId, status) => {
  setEnableLoading(fpsId);

  try {
    // const response = await postData(
        const response = await axios.post(
      `${process.env.REACT_APP_URL}/api/dkr/enable_download`,
      {
        month,
        year,
        fpsId,
        status
      },
      {
        headers: {
          'X-React-Route': window.location.href
        }
      }
    );

    const { success, message: respMsg } = response.data || {};
        // const { success, message: respMsg } = response || {};


    if (success) {
      setData(prev =>
        prev.map(item =>
          item.fpsId === fpsId
            ? {
                ...item,
                ...(status === "D" && { downloadStatus: "Download Pending" }),
                ...(status === "P" && { policyStatus: "Download Pending" }),
                ...(status === "C" && { cbStatus: "Download Pending" })
              }
            : item
        )
      );
    }

    setMessage(respMsg || "Status updated.");
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong.";
    setMessage(errMsg);
  } finally {
    setEnableLoading(null);
  }
};



  // ---------- Loader ----------
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={30} />
      </Box>
    );
  }

  if (data.length === 0) {
    return <p align='center' className='response'>{message || "No data."}</p>;
  }


  return (
    <div>
      <table align='center' width='80%'>
        <thead>
          <tr className='tableheader'>
            <td colSpan={7}>{heading}</td>
          </tr>
          <tr className='tableheader'>
            <td>SI.NO</td>
            <td>District</td>
            <td>Office</td>
            <td>FPS ID</td>
            <td>DKR Download Status</td>
            <td>Policy Status</td>
            <td>CB Download Status</td>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={item.fpsId}>
              <td>{index + 1}</td>
              <td>{item.districtName}</td>
              <td>{item.officeName}</td>
              <td>{item.fpsId}</td>

              {/* ---------- DKR Download (D) ---------- */}
              <td>
                {item.downloadStatus === "Downloaded" ? (
                  <button
                    className="button"
                    onClick={() => handleEnable(item.fpsId, "D")}
                    disabled={enableLoading === item.fpsId}
                  >
                    {enableLoading === item.fpsId ? <CircularProgress size={18} /> : "Enable"}
                  </button>
                ) : item.downloadStatus}
              </td>

              {/* ---------- POLICY (P) ---------- */}
              <td>
                {item.policyStatus === "Downloaded" ? (
                  <button
                    className="button"
                    onClick={() => handleEnable(item.fpsId, "P")}
                    disabled={enableLoading === item.fpsId}
                  >
                    {enableLoading === item.fpsId ? <CircularProgress size={18} /> : "Enable"}
                  </button>
                ) : item.policyStatus}
              </td>

              {/* ---------- CB Download (C) ---------- */}
              <td>
                {item.cbStatus === "Downloaded" ? (
                  <button
                    className="button"
                    onClick={() => handleEnable(item.fpsId, "C")}
                    disabled={enableLoading === item.fpsId}
                  >
                    {enableLoading === item.fpsId ? <CircularProgress size={18} /> : "Enable"}
                  </button>
                ) : item.cbStatus}
              </td>
            </tr>
          ))}

          <tr>
            <td colSpan={7} align='center'>
              <button className='button' onClick={() => window.history.back()}>Back</button>
            </td>
          </tr>
        </tbody>
      </table>

      {message && <p align='center' className='response'>{message}</p>}
    </div>
  );
}

export default Dkr_Table;
